import Header from "./components/Header";
import Hero from "./components/Hero";
import Channels from "./components/Channels";
import OnsiteGallery from "./components/OnsiteGallery";
import HotAndPicks from "./components/HotAndPicks";
import Faq from "./components/Faq";
import AboutReport from "./components/AboutReport";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Header />
      <Hero />
      <Channels />
      <OnsiteGallery />
      <HotAndPicks />
      <Faq />
      <AboutReport />
      <Footer />
    </main>
  );
}